import React from "react";

const BadgeText = ({ fName, lName }) => {
  return (
    <div className="ui-icon ui-icon-sm flex-shrink-0  bg-secondary border-0 text-white">
      {fName.slice(0, 1).toUpperCase() + lName.slice(0, 1).toUpperCase()}
    </div>
  );
};

export default BadgeText;
